module.exports = __webpack_public_path__ + "media/aa_teaser.5aff386b.mp4";